import LoadingIcon from "components/Tools/LoadingIcon";
import presikLogo from "assets/img/logo.png";
import { cn } from "tools/ui";

function FullScreenLoading({ message = "Cargando...", overlay = false }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "fixed inset-0 z-50 flex flex-col items-center justify-center gap-6",
        overlay ? "bg-neutral-900/70 backdrop-blur-sm" : "bg-neutral-800",
      )}
    >
      <img src={presikLogo} alt="PRESIK" width={160} />
      <LoadingIcon size="40px" color="fill-yellow-400" />
      <p className="text-lg font-medium text-neutral-100">{message}</p>
    </div>
  );
}

export default FullScreenLoading;
